import { InjectionToken } from '@angular/core';
import { WineryStoryResponse, WineryStoryUpdatePayload } from '../models/winery-story';

export interface WineryStoryApi {
  fetchStory(wineryId?: string): Promise<WineryStoryResponse>;
  updateStory(payload: WineryStoryUpdatePayload, wineryId?: string): Promise<WineryStoryResponse>;
}


export const WINERY_STORY_API = new InjectionToken<WineryStoryApi>('WINERY_STORY_API');
